module.exports = __webpack_public_path__ + "static/media/left_arrow_blue.aebf5776.svg";